/**
 * One or more email addresses, typed by a host in one field. Splitting lives here
 * so the engine, the routes and the two screens all read a list the same way.
 */

/** Something that looks like an address: one @, something either side, a dotted domain. */
function looksLikeAddress(value: string): boolean {
  const at = value.indexOf("@");
  if (at <= 0 || at !== value.lastIndexOf("@")) return false;
  const local = value.slice(0, at);
  const domain = value.slice(at + 1);
  if (!local || !domain) return false;
  if (/\s/.test(value)) return false;
  const dot = domain.lastIndexOf(".");
  return dot > 0 && dot < domain.length - 1;
}

/**
 * Every address in one field, in the order typed. Commas, semicolons and
 * whitespace all separate; blanks, duplicates and anything that is not an
 * address are dropped.
 */
export function splitAddresses(text: string): string[] {
  const out: string[] = [];
  for (const part of String(text ?? "").split(/[,;\s]+/)) {
    const address = part.trim().toLowerCase();
    if (!address || !looksLikeAddress(address)) continue;
    if (!out.includes(address)) out.push(address);
  }
  return out;
}

/** The list as it is stored and shown: one comma and a space between addresses. */
export function joinAddresses(list: string[]): string {
  return list.join(", ");
}

/** The list as a person says it: "a@x.com", "a@x.com and b@x.com", "a@x.com, b@x.com and c@x.com". */
export function addressesLabel(list: string[]): string {
  const parts = list.filter(Boolean);
  if (parts.length <= 1) return parts[0] ?? "";
  return `${parts.slice(0, -1).join(", ")} and ${parts[parts.length - 1]}`;
}
